import { Bell, Contact, ListOrdered, Store, Users, UsersRound } from 'lucide-react';
import { VERTICAL_COMPARISON } from '../comparisonMatrix';
import type { LandingConfig } from '../types';

export const golfTeachersConfig: LandingConfig = {
  slug: 'golf-teachers',
  namespace: 'landing-golf-teachers',
  analyticsId: 'for-golf-teachers',
  canonicalPath: '/for-golf-teachers',
  ogImagePath: '/images/og-golf-teachers.jpg',
  heroImage: '/images/hero-golf-teachers',
  // Order matches landing-golf-teachers:features.items[]
  featureIcons: [Store, UsersRound, ListOrdered, Bell, Contact, Users],
  comparison: VERTICAL_COMPARISON,
};
